export default __webpack_public_path__ + "static/media/shalimargarden.0d0ded6d.jpg";